import { useEffect, useRef } from 'react';
import { setupScrollListener } from '../utils/scrollUtils';

export const useGanttViewport = ({
	loadMore,
	loadingMore,
	hasMorePages,
	servicesLength
}) => {
	const scrollContainerRef = useRef();

	useEffect(() => {
		const outerContainer = scrollContainerRef.current;
		if (!outerContainer || servicesLength === 0) {
			return;
		}

		let cleanupFn = null;

		const initScrollListener = async () => {
			cleanupFn = await setupScrollListener(
				outerContainer,
				loadMore,
				hasMorePages,
				loadingMore
			);
		};

		initScrollListener();

		return () => {
			if (cleanupFn) cleanupFn();
		};
	}, [loadMore, loadingMore, hasMorePages, servicesLength]);

	return { scrollContainerRef };
};